import React, { useContext } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { LocationContext } from '@BUP/contexts/LocationContext'
import DataPage from '@BUP/pages/Data'
import DiagnosticPage from '@BUP/pages/Data/diagnostic'

const DataNavigation = () => {
  const locale = useContext(LocationContext)
  const organizationCountry = locale?.country
  return (
    <Routes>
      {organizationCountry === 'Spain' ? (
        <Route path='*' element={<Navigate to='/' />} />
      ) : (
        <>
          <Route
            path='/'
            element={<DataPage />}
          />
          <Route
            path='diagnostic'
            element={<DiagnosticPage />}
          />
          <Route
            path='*'
            element={<Navigate to='/' />}
          />
        </>
      )}
    </Routes>
  )
}

export default DataNavigation
